<div class="page-title__bar">
  <h2 class="title">Automation Report</h2>
</div>

<div class="tab-content" id="myTabContent">
  <div style="margin: 20px">
    <app-automation-order-details
      (reloadGrid)="reloadTable($event)"
      [order]="orderDetails"
      [assistantInfo]="assistantInfo"
      [assistantUID]="this.user.uid"
      [assistantPractice]="assistantPractice"
      [appointments]="true"
      [tasks]="true"
      [attachments]="true"
      (getPendingOrders)="getPendingOrders()"
    ></app-automation-order-details>
  </div>

  <!-- Orders -->
  <div class="right__panel calendar-data__wrapper">
    <div class="table-data__wrapper table-responsive calendar-data--table">
      <div class="d-flex justify-content-between align-items-center mb-3 width-parent">
        <h2 class="title">MRI Orders</h2>
        <div class="user-actions">
          <select
            ngbTooltip="Search Criteria"
            (change)="onChangeSearchCriteria($event)"
          >
            <option value="patient_name">Patient Name</option>
            <option value="provider_name">Provider Name</option>
            <option value="mrn">MRN</option>
          </select>
          <div class="input-group">
            <input
              #searchBar
              type="search"
              (keyup.enter)="filterUsers($event)"
              (search)="filterUsers($event, true)"
              [(ngModel)]="searchKeyword"
              class="form-control change"
              placeholder="Search"
            />
            <div class="input-group-append" (click)="filterUsers($event)">
              <span class="input-group-text">
                <img
                  src="../../../assets/icons/daily-screening.svg"
                  alt="search"
                />
              </span>
            </div>
          </div>
          <button
            type="button"
            ngbTooltip="Upload LCD Policy Document"
            placement="left"
            class="filter__panel btn-demo"
            (click)="uploadLCDPolicyDocument()"
          >
          <i class="fa fa-upload" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            ngbTooltip="Add LCD Policy"
            placement="left"
            class="filter__panel btn-demo"
            (click)="addLCDPolicy()"
          >
          <i class="fa fa-plus-circle" aria-hidden="true"></i>
          </button>
          <button
            type="button"
            ngbTooltip="LCD Coverage Report"
            placement="left"
            class="filter__panel btn-demo"
            (click)="lcdPolicyDocuments()"
          >
         <i class="fa fa-address-card-o" aria-hidden="true"></i>
          </button>
        </div>
      </div>
      <div>
        <!-- <app-table-pagination-client
          [headers]="orderTableHeaders"
          [data]="selectedUserOrdersTableData"
          [paginateId]="2"
          [hasActions]="true"
          [policyDocument]="policyDocuments"
          [orderByFunction]="orderBy"
          [selectContent]="selectOrder"
          [selectedContent]="selectedOrder"
          [paginationFirstPage]="firstPage"
          [paginationPrevPage]="prevPage"
          [paginationNextPage]="nextPage"
          [paginationLastPage]="lastPage"
          [paginationCustomPage]="customPage"
          [serverSidePagination]="tablePages"
          [pageSize]="pageSize"
          [currentPage]="1"
        >
        </app-table-pagination-client> -->
        <!-- dowload LCD Policy Document commented -->
        <app-table-pagination-client
        [headers]="orderTableHeaders"
        [data]="selectedUserOrdersTableData"
        [paginateId]="2"
        [hasActions]="true"
        [policyDocument]="policyDocuments"
        [downloadFunction]="downloadLCDPolicyDocument"
        [orderByFunction]="orderBy"
        [selectContent]="selectOrder"
        [selectedContent]="selectedOrder"
        [paginationFirstPage]="firstPage"
        [paginationPrevPage]="prevPage"
        [paginationNextPage]="nextPage"
        [paginationLastPage]="lastPage"
        [paginationCustomPage]="customPage"
        [serverSidePagination]="tablePages"
        [pageSize]="pageSize"
        [currentPage]="1"
      >
      </app-table-pagination-client>
      </div>
    </div>
  </div>
</div>
